import React from 'react';
import styled, { keyframes } from 'styled-components';

interface DotSpinnerProps {
  color?: string;
  size?: number;
  speed?: number;
  gap?: number;
}

const DotSpinner: React.FC<DotSpinnerProps> = ({
  color = '#3B82F6',
  size = 8,
  speed = 1000,
  gap = 8,
}) => {
  return (
    <SpinnerContainer gap={gap}>
      <Dot color={color} size={size} speed={speed} delay={0} />
      <Dot color={color} size={size} speed={speed} delay={200} />
      <Dot color={color} size={size} speed={speed} delay={400} />
    </SpinnerContainer>
  );
};

/**
 * '중심'을 기준으로 -1px ~ +1px 사이를 오가도록 수정
 * 0%, 100% => 위(-1px), 50% => 아래(+1px)
 */
const bounce = keyframes`
  0%, 100% {
    transform: translateY(-1px);
  }
  50% {
    transform: translateY(1px);
  }
`;

const SpinnerContainer = styled.div<{ gap?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ gap }) => gap || 8}px;
`;

const Dot = styled.div<{
  color?: string;
  size?: number;
  delay?: number;
  speed?: number;
}>`
  width: ${({ size }) => size || 8}px;
  height: ${({ size }) => size || 8}px;
  background-color: ${({ color }) => color || '#3B82F6'};
  border-radius: 50%;
  animation: ${bounce} ${({ speed }) => speed || 1000}ms infinite;
  animation-delay: ${({ delay }) => delay || 0}ms;
`;

export default DotSpinner;
